<template>
  <div
    ref="legoDropdown"
    class="lego-dropdown lego-input"
    :class="dropdownClass"
    :style="[dropdownWidth, dropdownHeight]"
    v-click-outside="toggleItemOuter"
  >
    <div class="lego-dropdown__title" @click="toggleItem">
      <div
        class="lego-dropdown__selected"
        :style="dropdownTitleStyle"
        v-lego-tooltip:ellipsis="getSelectedItemText"
      >
        <span>{{ getSelectedItemText }}</span>
      </div>
      <lego-icon-wrapper class="lego-dropdown__title-icon">
        <lego-icon
          class="lego-dropdown__icon"
          icon-type="df"
          icon="arrow_down"
          :size:="16"
          :style="caretStyle"
        />
      </lego-icon-wrapper>
    </div>
    <lego-dropdown-menu
      :items="items"
      :isItemShowing="isItemShowing"
      :autoComplete="autoComplete"
      :multiSelect="true"
      :selectAll="selectAll"
      :selectAllText="selectAllText"
      :selectAllChecked="selectAllChecked"
      :selectAllCheckedIcon="selectAllCheckedIcon"
      :applyBtn="applyBtn"
      :width="itemWidth"
      :itemMaxHeight="itemMaxHeight"
      :filteredItemList="filteredItemList"
      :itemValue="itemValue"
      :itemText="itemText"
      :selectedItem="selected"
      :prevSelected="prevSelected"
      :focusedItemIndex="focusedItemIndex"
      :focusedDepthIndex="focusedDepthIndex"
      :appendToBody="appendToBody"
      :menuDirection="menuDirection"
      :small="sm || small"
      :isTooltip="isTooltip"
      parent="legoDropdown"
      @click="onClickItem"
      @selectAll="clickSelectAll"
      @apply="onApplyClick"
    />
    <div
      v-if="messageShow"
      class="lego-dropdown__message lego-validator__message"
      :class="messageClass"
      :style="customValidationStyle"
    >
      <!--glue
      -->
      {{ messageShow }}
      <!--glue
      -->
    </div>
  </div>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin.js';
import legoDropdownMenu from './legoDropdownMenu';
export default {
  mixins: [i18nMixin],
  emits: ['update:modelValue'],
  components: {
    legoDropdownMenu
  },
  props: {
    modelValue: {
      type: Array,
      validator: function (val) {
        return Array.isArray(val);
      },
      default: () => []
    },
    placeholder: { type: String, default: '' },
    applyBtn: { type: Boolean, default: false },
    selectAll: { type: Boolean, default: false },
    selectAllText: { type: String, default: '' },
    isTooltip: { type: Boolean, default: false },
    maxSelect: { type: [Number, String], default: '' },
    messageErrorMaxSelect: { type: String, default: '' }
  },
  data() {
    return {
      selected: [],
      prevSelected: []
    };
  },
  computed: {
    getSelectedItemText() {
      const ableItem = this.items.filter((item) => !item.disabled);
      if (this.selected.length === 0) {
        return this.placeholder || this.t('label.notSelect');
      } else if (this.selected.length === ableItem.length) {
        return this.selectAllText;
      } else {
        let itemText = [];
        this.selected.forEach((item) => {
          if (typeof this.itemText === 'function') {
            itemText.push(this.itemText(item));
          } else {
            itemText.push(item[this.itemText]);
          }
        });
        return itemText.sort().join(', ');
      }
    },
    selectAllChecked() {
      return this.selected.length > 0;
    },
    selectAllCheckedIcon() {
      const ableItem = this.items.filter((item) => {
        return !item.disabled;
      });
      return this.selected.length === ableItem.length ? 'checked' : 'indeterminate';
    }
  },
  watch: {
    isItemShowing() {
      if (this.applyBtn && this.isItemShowing) {
        this.prevSelected = this.selected.slice();
      }
    },
    modelValue() {
      if (!_.isEqual(this.selected, this.modelValue)) {
        this.hasError = false;
        this.errorMessage = '';
        this.selected = this.modelValue.slice();
      }
    }
  },
  mounted() {
    this.selected = this.modelValue.slice();
  },
  methods: {
    onClickItem(item) {
      let index = _.findIndex(this.selected, item, this.applyBtn);
      if (index > -1) {
        this.selected.splice(index, 1);
      } else {
        if (this.maxSelect && this.selected.length >= this.maxSelect) {
          this.hasError = true;
          this.errorMessage = this.messageErrorMaxSelect;
          return;
        }
        this.selected.push(item);
      }
      if (!this.applyBtn) {
        this.$emit('update:modelValue', this.selected.slice());
      }
    },
    toggleItem() {
      this.resetSelected();
      this.isItemShowing = !this.isItemShowing;
    },
    toggleItemOuter() {
      this.resetSelected();
      this.isItemShowing = false;
    },
    resetSelected() {
      if (this.applyBtn && this.isItemShowing) {
        this.selected = this.prevSelected.slice();
      }
    },
    onApplyClick() {
      this.$emit('update:modelValue', this.selected.slice());
      this.isItemShowing = false;
    },
    clickSelectAll() {
      const ableItem = this.items.filter((item) => {
        return !item.disabled;
      });

      if (this.maxSelect && ableItem.length > this.maxSelect) {
        this.hasError = true;
        this.errorMessage = this.messageErrorMaxSelect;
        return;
      }

      if (this.selected.length === ableItem.length) {
        this.selected.splice(0, this.selected.length);
      } else {
        this.selected = ableItem;
      }
      //if (!this.applyBtn) {
      this.$emit('update:modelValue', this.selected.slice());
      // }
    }
  }
};
</script>
